import { useParams } from "react-router-dom";
import { type RetailerType, RETAILER_CONFIGS } from "../config/retailers";

export function useRetailer(): RetailerType {
  const { retailer } = useParams<{ retailer: string }>();
  const normalizedRetailer =
    retailer === "amazon_online"
      ? "amazon"
      : retailer === "kohls_online"
        ? "kohls"
        : retailer;

  // Default to walmart if no retailer is specified or if it's not a valid retailer
  if (normalizedRetailer && normalizedRetailer in RETAILER_CONFIGS) {
    return normalizedRetailer as RetailerType;
  }

  return "walmart";
}
